import { css } from "aphrodite";
import styles from "./styles";
import { Button, Typography } from "@mui/material";

const AnimatedButton = ({
    isSelected = false,
    text = "",
    onClick = () => {},
    ariaLabel,
    "aria-label": ariaLabelAttr,
}) => {
    const resolvedAriaLabel = ariaLabel || ariaLabelAttr;

    return (
        <Button
            variant="contained"
            className={css(styles.button)}
            disableElevation
            disableRipple
            onClick={onClick}
            color={isSelected ? "secondary" : "primary"}
            aria-label={resolvedAriaLabel}
            aria-pressed={isSelected}
        >
            <Typography variant="body1" className={css(styles.text)}>
                {text}
            </Typography>
        </Button>
    );
};

export default AnimatedButton;
